export default __webpack_public_path__ + "8af93d611aef85e96bfdc707d0ec1330.png";